var map = {
	"./": 18305,
	"./App": 9555,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./BillComponents/BillPage": 50536,
	"./BillComponents/BillPage.js": 50536,
	"./BillComponents/MainBill": 43549,
	"./BillComponents/MainBill.js": 43549,
	"./Cart": 86028,
	"./Cart.js": 86028,
	"./CheckBackend": 19310,
	"./CheckBackend.js": 19310,
	"./Contact": 71265,
	"./Contact.js": 71265,
	"./ContactEle": 11873,
	"./ContactEle.js": 11873,
	"./ErrorPage": 57191,
	"./ErrorPage.js": 57191,
	"./Features.module.css": 80786,
	"./Firebasedata": 80962,
	"./Firebasedata.js": 80962,
	"./FirstPage/Features": 60412,
	"./FirstPage/Features.js": 60412,
	"./FirstPage/FirstPage": 3402,
	"./FirstPage/FirstPage.js": 3402,
	"./FirstPage/HomePage": 16461,
	"./FirstPage/HomePage.js": 16461,
	"./FirstPage/Premium": 16153,
	"./FirstPage/Premium.js": 16153,
	"./FirstPage/Products": 75842,
	"./FirstPage/Products.js": 75842,
	"./FirstPage/Testimonial": 34970,
	"./FirstPage/Testimonial.js": 34970,
	"./Footer": 10705,
	"./Footer.js": 10705,
	"./Header": 58831,
	"./Header.js": 58831,
	"./HomePage.module.css": 37570,
	"./LoginLogout/Account": 20584,
	"./LoginLogout/Account.js": 20584,
	"./LoginLogout/RegisterForm": 92902,
	"./LoginLogout/RegisterForm.js": 92902,
	"./PrdtDetailDesc": 61372,
	"./PrdtDetailDesc.js": 61372,
	"./PrdtDetailPage": 51262,
	"./PrdtDetailPage.js": 51262,
	"./ProductDisplay": 29324,
	"./ProductDisplay.js": 29324,
	"./ProductsData": 27422,
	"./ProductsData.js": 27422,
	"./SecondPage": 41891,
	"./SecondPage.js": 41891,
	"./SingleCart": 39081,
	"./SingleCart.js": 39081,
	"./SingleProduct": 89254,
	"./SingleProduct.js": 89254,
	"./basketitem": 64709,
	"./basketitem.js": 64709,
	"./firebase-config/firebase": 80326,
	"./firebase-config/firebase.js": 80326,
	"./images/app-store.png": 13851,
	"./images/buy-1.jpg": 40389,
	"./images/buy-2.jpg": 60987,
	"./images/buy-3.jpg": 6022,
	"./images/cart.png": 86580,
	"./images/category-1.jpg": 62823,
	"./images/category-2.jpg": 61937,
	"./images/category-3.jpg": 39973,
	"./images/exclusive.png": 74722,
	"./images/gallery-1.jpg": 63051,
	"./images/gallery-2.jpg": 35870,
	"./images/gallery-3.jpg": 21693,
	"./images/gallery-4.jpg": 15145,
	"./images/image1.png": 25236,
	"./images/img-credit.txt": 2494,
	"./images/logo-adidas.png": 17067,
	"./images/logo-allensolly.png": 19556,
	"./images/logo-coca-cola.png": 35718,
	"./images/logo-godrej.png": 35247,
	"./images/logo-oppo.png": 57313,
	"./images/logo-paypal.png": 95442,
	"./images/logo-peter.png": 84795,
	"./images/logo-philips.png": 86857,
	"./images/logo-puma.png": 44746,
	"./images/logo-uspa.png": 65976,
	"./images/logo-white.png": 68364,
	"./images/logo.png": 96338,
	"./images/mahe.JPG": 24322,
	"./images/menu.png": 47121,
	"./images/play-store.png": 77380,
	"./images/product-1.jpg": 60096,
	"./images/product-10.jpg": 87931,
	"./images/product-11.jpg": 68799,
	"./images/product-12.jpg": 78258,
	"./images/product-2.jpg": 34896,
	"./images/product-3.jpg": 14965,
	"./images/product-4.jpg": 23573,
	"./images/product-5.jpg": 99264,
	"./images/product-6.jpg": 66495,
	"./images/product-7.jpg": 1652,
	"./images/product-8.jpg": 18948,
	"./images/product-9.jpg": 76814,
	"./images/shoppingcartimg.png": 13049,
	"./images/ultra.png": 56569,
	"./images/user-1.png": 68660,
	"./images/user-2.png": 24155,
	"./images/user-3.png": 65292,
	"./index": 18305,
	"./index.js": 18305,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./storefiles/authenticated": 76022,
	"./storefiles/authenticated.js": 76022,
	"./storefiles/billamount": 55770,
	"./storefiles/billamount.js": 55770,
	"./storefiles/cartItems": 82512,
	"./storefiles/cartItems.js": 82512,
	"./storefiles/globalstore": 31184,
	"./storefiles/globalstore.js": 31184
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;